var exports = {
  "k": "xe564cbfb--d688d6--container",
};

module.exports = exports;
